import {
  PropsWithChildren,
  ReactNode,
  useCallback,
  useRef,
  useState
} from 'react';
import { useNavigate } from 'react-router';
import { BoxIcon } from '#atoms';
import useOutsideClickAndEscPress from '#hooks/useOutsideClickAndEscPress';
import {
  ChildrenContainer,
  Container,
  HeaderContainer,
  ButtonDot,
  ButtonPrev,
  DotWrapper
} from './styles';

interface Props {
  prevRoute?: string;
  headerbarType?: 'fixed' | 'relative';
  defaultBackground?: boolean;
  willBeScroll?: boolean;
  dotComponent: ReactNode;
  disableDotButton?: boolean;
  onPrevCallback?: () => void;
  onClickDot?: () => void;
}

export function PrevHeaderBarThreeDotTemplate({
  prevRoute,
  headerbarType = 'fixed',
  defaultBackground,
  dotComponent,
  children,
  disableDotButton,
  onPrevCallback,
  onClickDot
}: PropsWithChildren<Props>) {
  const dotRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [isOpenDotContent, setIsOpenDotContent] = useState(false);

  useOutsideClickAndEscPress(dotRef, () => {
    setIsOpenDotContent(false);
  });

  const onClickArrow = useCallback(() => {
    // type 문제로 인한 nullish 처리가 불가
    if (prevRoute) navigate(prevRoute);
    else navigate(-1);
    onPrevCallback && onPrevCallback();
  }, [prevRoute]);

  const handleClickDot = () => {
    setIsOpenDotContent(prev => !prev);
    if (onClickDot) {
      onClickDot();
    }
  };

  return (
    <>
      <Container>
        <HeaderContainer
          headerbarType={headerbarType}
          defaultBackground={defaultBackground}
        >
          <ButtonPrev onClick={onClickArrow}>
            <BoxIcon
              type="prev-arrow"
              boxColor="transparent"
              size={18}
              onlyIcon
            />
          </ButtonPrev>

          {!!dotComponent && !disableDotButton && (
            <DotWrapper ref={dotRef}>
              <ButtonDot onClick={handleClickDot}>
                <BoxIcon
                  type="dots_vertical_rounded"
                  boxColor="transparent"
                  size={18}
                  onlyIcon={true}
                />
              </ButtonDot>

              {isOpenDotContent && dotComponent}
            </DotWrapper>
          )}
        </HeaderContainer>
        <ChildrenContainer headerbarType={headerbarType}>
          {children}
        </ChildrenContainer>
      </Container>
    </>
  );
}
